import * as React from "react";
import { Controller } from "react-hook-form";
import { DatePicker } from "@mui/x-date-pickers";
import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

interface FormDatePickerProps {
    name: string,
    control: any,
    props: { disabled?: boolean, label: string, minDate?: Date, maxDate?: Date }
}

export const FormDatePicker = ({ name, control, props }: FormDatePickerProps) => {

    const { t } = useTranslation('finance');

    return (
            <Controller
                    name={name}
                    control={control}
                    render={({ field: { name, value, onChange }, fieldState: { error } }) =>
                            <DatePicker {...props}
                                        value={value || null}
                                        onChange={(date) => {
                                            onChange(date ? date : null)
                                        }}
                                        views={['day']}
                                        renderInput={(params) =>
                                                <TextField {...params} fullWidth
                                                           error={!!error}
                                                           helperText={(error && error.type === 'required' && t('forms.required-field', { label: props.label })) || error?.message}
                                                />}
                                        inputFormat={"L"}
                            />
                    }
            />
    );
}

export default FormDatePicker;